module.exports = __webpack_public_path__ + "img/header-01.992eab2f.png";